<template>
  <div>
    <div class="user-card child-v-center">
      <img :src="avatarUrl" class="avatar-small">
      <div class="user-info">
        <div class="full-name">{{ $store.state.userInfo.fullName }}</div>
        <div class="mobile-number">{{ $store.state.userInfo.mobileNumber }}</div>
      </div>
    </div>
    <div class="user-card security-tabs">
      <div class="tab-arrow arrow-let">&lt;</div>
      <div class="tab-arrow arrow-right">&gt;</div>
      <md-tabs v-model="activeName">
        <md-tab-pane name="bank" :label="$t('bankAccount')">
          <security-bank ref="bank"></security-bank>
        </md-tab-pane>
        <md-tab-pane name="password" :label="$t('changePassword')">
          <security-password></security-password>
        </md-tab-pane>
        <md-tab-pane name="profile" :label="$t('personalInformation')">
          <security-profile ref="profile"></security-profile>
        </md-tab-pane>
      </md-tabs>
    </div>
  </div>
</template>

<script>
import { Tabs, TabPane } from 'mand-mobile'
import SecurityBank from '@/components/user/security/SecurityBank'
import SecurityPassword from '@/components/user/security/SecurityPassword'
import SecurityProfile from '@/components/user/security/SecurityProfile'

export default {
  i18n: {
    messages: {
      en: {
        bankAccount: 'Bank Account',
        changePassword: 'Change password',
        personalInformation: 'Edit Profile',
      },
      id: {
        bankAccount: 'Ganti nomor akun',
        changePassword: 'Ganti password',
        personalInformation: 'Informasi Pribadi',
      },
    },
  },
  components: {
    SecurityBank,
    SecurityPassword,
    SecurityProfile,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  },
  data() {
    return {
      activeName: 'bank',
    }
  },
  computed: {
    avatarUrl() {
      return require('@/assets/image/header/account_s@2x.png') // eslint-disable-line global-require
    },
  },
}
</script>

<style lang="stylus" scoped>
.child-v-center {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  font-size: 14px;
}

.avatar-small {
  height: 40px;
  width: 40px;
  border-radius: 100px;
}

.user-info {
  margin-left: 16px;
}

.full-name {
  font-size: 16px;
  font-weight: bold;
  line-height: 18px;
  margin-bottom: 4px;
}

.mobile-number {
  font-size: 12px;
  line-height: 14px;
}

.security-tabs /deep/ {
  position: relative;
  .md-tab-bar {
    margin: 0 10px;
    padding: 0 5px;
  }
  .md-tab-title {
    min-width: 120px;
  }
  .tab-arrow {
    position: absolute;
    top: 32px;
    color: #999;
    font-size: 12px;
  }
  .arrow-left {
    left: 0;
  }
  .arrow-right {
    right: 16px;
  }
}
</style>
